import * as React from 'react';

require('../css/header.css');

interface Props {
  children?: React.ReactNode;
  elementProps?: Object;

  // Adding a property to add external css class. 
  headingClassName?: string;
  spanClassName?: string;

  onEditClick?(): void;
}

const Header = (props: Props) => {
  // Check if external css properties comes from parent
  let headingUserClass = props.headingClassName === null ? '' : props.headingClassName;
  let spanUserClass = props.spanClassName === null ? '' : props.spanClassName;

  if (props.onEditClick) {
    return (
      <h5 className={headingUserClass} {...props.elementProps}>
        {props.children}
        <span className={`edit ${spanUserClass}`} onClick={props.onEditClick}>
          edit
        </span>
      </h5>
    );
  }

  return <h5 className={headingUserClass} {...props.elementProps}>{props.children}</h5>;
};

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.tsx